export default __webpack_public_path__ + "static/media/IMG-2735.62595672.jpg";